module.exports = {
	'_decimalSeparator': ',',
	'_thousandSeparator': ' ',
	'_date_millisecond': 'mm:ss SSS',
	'_date_second': 'HH:mm:ss',
	'_date_minute': 'HH:mm',
	'_date_hour': 'HH:mm',
	'_date_day': 'yyyy-MM-dd',
	'_date_week': 'ww',
	'_date_month': 'MMM',
	'_date_year': 'yyyy',
	'_duration_millisecond': 'SSS',
	'_duration_second': 'ss',
	'_duration_minute': 'mm',
	'_duration_hour': 'hh',
	'_duration_day': 'dd',
	'_duration_week': 'ww',
	'_duration_month': 'MM',
	'_duration_year': 'yyyy',
	'January': 'januari',
	'February': 'februari',
	'March': 'mars',
	'April': 'april',
	'May': 'maj',
	'June': 'juni',
	'July': 'juli',
	'August': 'augusti',
	'September': 'september',
	'October': 'oktober',
	'November': 'november',
	'December': 'december',
	'Jan': 'jan.',
	'Feb': 'feb.',
	'Mar': 'mars',
	'Apr': 'apr.',
	'May(short)': 'maj',
	'Jun': 'juni',
	'Jul': 'juli',
	'Aug': 'aug.',
	'Sep': 'sep.',
	'Oct': 'okt.',
	'Nov': 'nov.',
	'Dec': 'dec.',
	'Sunday': 'söndag',
	'Monday': 'måndag',
	'Tuesday': 'tisdag',
	'Wednesday': 'onsdag',
	'Thursday': 'torsdag',
	'Friday': 'fredag',
	'Saturday': 'lördag',
	'Sun': 'sön',
	'Mon': 'mån',
	'Tue': 'tis',
	'Wed': 'ons',
	'Thu': 'tor',
	'Fri': 'fre',
	'Sat': 'lör',
	'Zoom Out': 'Zooma ut',
	'Legend': 'Teckenförklaring',
	'Loading': 'Läser in',
	'From %1 to %2': 'Från %1 till %2',
	'From %1': 'Från %1',
	'To %1': 'Till %1',
	'download': 'Spara som:',
	'Use TAB to select grip buttons or left and right arrows to change selection':
		'Dra i reglaget för att flytta urvalet'
};
